import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { GamesComponent } from './games/games.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { BannerComponent } from './banner/banner.component';
import { MobileGameTileComponent } from './mobile-game-tile/mobile-game-tile.component';
import { MobileNavbarComponent } from './navbar/mobile-navbar.component';
import { JackpotCounterMobileComponent } from './jackpot-counter-mobile/jackpot-counter-mobile.component'
import { HighlightSearchPipe } from 'src/app/pipes/highlight-search.pipe';
import { JackpotCounterComponent } from '../jackpot-counter/jackpot-counter';
import { FilterDataPipe } from 'src/app/pipes/filter-data.pipe';
import { MobileKeywordsComponent } from './mobile-keywords/mobile-keywords.component';

@NgModule({
  declarations: [
    SearchbarComponent,
    GamesComponent,
    BannerComponent,
    MobileNavbarComponent,
    JackpotCounterMobileComponent,
    MobileGameTileComponent,
    MobileKeywordsComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    FormsModule,
    IonicModule,
    HighlightSearchPipe,
    JackpotCounterComponent,
    FilterDataPipe
  ],
  exports:[
    SearchbarComponent,
    GamesComponent,
    BannerComponent,
    MobileNavbarComponent,
    JackpotCounterMobileComponent,
    MobileGameTileComponent,
    MobileKeywordsComponent
  ]
})
export class MobileModule { }
